{
  "id": "campaign-077",
  "name": "Breezy Range",
  "seed": "campaign:77",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....~....._.",
    "...~~ooo.._.",
    "...h~oFoh._.",
    ".....ooo.._.",
    "....s....._.",
    "...ss...#._.",
    "....h..h.._~",
    "......#..._.",
    "..h......h_~",
    ".......,.._.",
    "..W....,,W_.",
    ".......,,._.",
    ".....#.,,,_.",
    "....#...,._.",
    "..b,,,...b_.",
    "....,....._.",
    "...#....#...",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 17
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 15
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 11
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 77,
  "biome": "golf",
  "par": {
    "reel": 7618,
    "push": 6344,
    "selfPropelled": 5982,
    "tractor": 4985,
    "zeroTurn": 4146,
    "fairway": 2842
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 20,
      "selfPropelled": 10,
      "tractor": 24,
      "zeroTurn": 6,
      "fairway": 13
    }
  }
}
